import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine, VerticalLine } from '../../../components/shapes/Line'
import { TabsContext } from '../../../components/tabs/TabsContext'
import { useTabsOptions } from './tabs/_data/tabsOptions'
import ControlledModal from '../../../components/modals/ControlledModal'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import SideData from './SideData'
import TabsContent from '../../../components/tabs/TabsContent'
import Scroll from '../../../components/helpers/Scroll'

const ShowLogModal = props => {
  const tabsOptions = useTabsOptions()

  return (
    <ControlledModal width="85rem" height="85vh" {...props}>
      <TabsContext options={tabsOptions}>
        <ModalHeader />

        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={4} />

        <FlexGrid justify="space-between" align="stretch" paddingGutter={0.5} minHeight="auto">
          <FlexCol width="62rem">
            <TabsContent />
          </FlexCol>

          <FlexCol alignSelf="stretch" hideOn="sm">
            <VerticalLine thin lineColor={COLORS.light2} fullHeight />
          </FlexCol>

          <FlexCol flex={1}>
            <Scroll maxHeight="calc(85vh - 190px)" overflowX="hidden" overflowY="auto">
              <SideData />
            </Scroll>
          </FlexCol>
        </FlexGrid>
      </TabsContext>
    </ControlledModal>
  )
}

export default ShowLogModal
